import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/LoginView.vue'

const routes = [
  {
    path: '/',
    name: 'main',
    redirect: '/dashboard',
    component: () => import(/* webpackChunkName: "main" */ '@/views/MainPage.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/components/DashboardBody.vue')
      },
      {
        path: 'healthindex',
        name: 'healthindex',
        component: () => import(/* webpackChunkName: "healthindex" */ '@/components/HealthIndexBody.vue')
      },
      {
        path: 'inbox',
        name: 'inbox',
        component: () => import(/* webpackChunkName: "inbox" */ '@/components/InboxBody.vue')
      },
      {
        path: 'result',
        name: 'result',
        component: () => import(/* webpackChunkName: "result" */ '@/components/PredictionStatusComp.vue')
      },
      {
        path: 'result/:id',
        name: 'patientInfo',
        component: () => import(/* webpackChunkName: "result" */ '@/components/PatientInfoBody.vue')
      },
      {
        path: 'history',
        name: 'history',
        component: () => import(/* webpackChunkName: "history" */ '@/components/HistoryBody.vue')
      },
      {
        path: 'myaccount',
        name: 'myaccount',
        component: () => import(/* webpackChunkName: "myaccount" */ '@/components/MyAccountBody.vue')
      },
      {
        path: 'usersetting',
        name: 'usersetting',
        component: () => import(/* webpackChunkName: "usersetting" */ '@/components/UserSettingBody.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/login/otp',
    name: 'otp',
    component: () => import(/* webpackChunkName: "otp" */ '../views/OTPView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
